import React from "react";
import { Headline } from "@jobmatchme/ui";
import { Link } from "gatsby";
import styles from "./style.module.scss";
import backIcon from "./back.svg";

const NewsHeadline = ({ pathname }) => {
  const pcBase = "/de/wissen/fahrer/";
  const bcBase = "/de/wissen/arbeitgeber/";
  const knowledgeBase = "/de/wissen/";
  let backUrl = "/";

  // Go back to pc/bc page
  if (pathname === pcBase || pathname === bcBase) {
    if (pathname === pcBase) {
      backUrl = "/de/fahrer/";
    }
    if (pathname === bcBase) {
      backUrl = "/de/arbeitgeber/";
    }
    return (
      <Headline size={1}>
        <a className={styles.backLink} href={backUrl}>
          <img src={backIcon} alt="Zurück" />
        </a>
        <a href={backUrl} className={styles.backLinkHeadline}>
          {getHeadline(pathname)}
        </a>
      </Headline>
    );
  }

  // Go back to pc/bc knowledge list
  if (
    pathname.includes(pcBase) ||
    pathname.includes(bcBase) ||
    pathname.includes(knowledgeBase)
  ) {
    if (pathname.includes(pcBase)) {
      backUrl = "/";
    }
    if (pathname.includes(bcBase)) {
      backUrl = "/";
    }
    return (
      <Headline size={1} pseudo>
        <Link to={backUrl} className={styles.backLink}>
          <img src={backIcon} alt="Zurück" />
        </Link>
        <Link to={backUrl} className={styles.backLinkHeadline}>
          {getHeadline(pathname)}
        </Link>
      </Headline>
    );
  }

  // Just go to the root site
  return (
    <Headline size={1} pseudo>
      <Link to="/" className={styles.backLink}>
        <img src={backIcon} alt="Zurück" />
      </Link>
      <Link to="/" className={styles.backLinkHeadline}>
        {getHeadline(pathname)}
      </Link>
    </Headline>
  );
};

const getHeadline = pathname => {
  return (
    <>
      Wissen
      {pathname.includes("/fahrer") && " für Fahrer"}
      {pathname.includes("/arbeitgeber") && " für Arbeitgeber"}
    </>
  );
};

export default NewsHeadline;
